import { createContext, Dispatch, SetStateAction } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { IndexName } from '@enums/IndexName';
import FilterDefinition from '@models/FilterDefinition';
import { OrderBy } from '@models/OrderBy';
import { TOrderProvidersBy } from '@models/OrderProvidersBy';
import { FilterGroup } from '@models/SearchFilter';
import { SearchQuery } from '@models/SearchQuery';
import SearchResults from '@models/SearchResults';
import { TitleBase } from '@models/Title';
import { CompatibilityMap } from '@utils/searchUtils';

export type SearchAndFilterValues = {
  filterCount: number;
  filterDefLoad: UseQueryResult<FilterDefinition[] | undefined>;
  filterTrigger: string;
  isReadonly?: boolean;
  pageNo: number;
  pageSize: number;
  provider?: string;
  queryResult: {
    error?: AxiosError | null;
    isLoading: boolean;
    titles?: SearchResults<TitleBase>;
  };
  searchQuery: SearchQuery;
  setOrderBy: Dispatch<SetStateAction<OrderBy[]>>;
  setOrderProvidersBy: Dispatch<SetStateAction<TOrderProvidersBy | undefined>>;
  setPageNo: (pageNo: number, replace?: boolean) => void;
  updateDistinctBy: (distinctBy?: string) => void;
  updateFilter: (filter: FilterGroup, queryText?: string) => void;
  updateIndexName: (indexName: IndexName, compatibilityMap: CompatibilityMap) => void;
  updateProvider: (provider?: string) => void;
  updateQueryText: (queryText: string) => void;
  updateSearchQuery: (searchQuery: SearchQuery) => void;
};

const SearchAndFilterContext = createContext<SearchAndFilterValues>({
  filterCount: 0,
  filterDefLoad: {} as UseQueryResult<FilterDefinition[]>,
  filterTrigger: '',
  pageNo: 0,
  pageSize: 0,
  queryResult: { isLoading: false },
  searchQuery: {
    filter: {} as FilterGroup,
    indexName: IndexName.Assets,
    orderBy: [],
    queryText: '',
  },
  setOrderBy: () => void 0,
  setOrderProvidersBy: () => void 0,
  setPageNo: () => void 0,
  updateDistinctBy: () => void 0,
  updateFilter: () => void 0,
  updateIndexName: () => void 0,
  updateProvider: () => void 0,
  updateQueryText: () => void 0,
  updateSearchQuery: () => void 0,
});

export default SearchAndFilterContext;
